import type { StorageInstance } from 'storage/domain/Storage'
import { getStorageInstance } from 'storage/services/getStorageInstance'

import { CART_IMAGES_CACHE } from '../../constants/constants'

interface CartImagesCacheProps {
	token?: string
	countryISO?: string
}

export const cartImagesCache = ({
	token,
	countryISO,
}: CartImagesCacheProps = {}): StorageInstance =>
	getStorageInstance({
		token,
		countryISO,
		cacheKey: CART_IMAGES_CACHE,
		maxDiffTimestamp: 1800000,
		isTokenCache: false,
		isCountryCache: false,
	})
